import React, { useState, useEffect } from 'react';
// ANTD
import { Select } from 'antd';
// API
import userAPI from 'app/API/user.service.api';

import parse from 'html-react-parser';

// INTL
import { FormattedMessage, useIntl } from 'react-intl';

// CONST
const { Option } = Select;

const FriendsSelect = (props) => {
  const { member = [] } = props;
  const [dataFriends, setDataFriends] = useState([]);

  useEffect(() => {
    if (props.authUser && props.authUser.id && member.length === 0) {
      userAPI
        .getFriendsById(props.authUser.id)
        .then((res) => {
          const { code, friends } = res;
          if (code === 200) {
            setDataFriends(friends);
          } else {
            console.log(res);
          }
        })
        .catch((err) => console.log(err));
    } else if (member.length > 0) {
      setDataFriends(props.member);
    } else {
      setDataFriends([]);
    }
  }, [props.authUser]);

  const intl = useIntl();

  return (
    <Select
      placeholder={intl.formatMessage({
        id: 'Select friends',
        defaultMessage: 'Select friends',
      })}
      size="small"
      onSelect={(value) => {
        props.getFriendToursShortInfoById(props.authUser.id, value);
      }}
      notFoundContent={intl.formatMessage({
        id: 'No friends',
        defaultMessage: 'No friends',
      })}
      dropdownClassName={props.className ? props.className : ''}
      // defaultValue="ALL TOURS"
    >
      {dataFriends.length > 0 ? (
        <>
          {/* <Option value="ALL TOURS" key={0}>
            <FormattedMessage id="ALL TOURS" defaultMessage="ALL TOURS" />
          </Option> */}
          {dataFriends.map((item) => (
            <Option value={item.id} key={item.id}>
              {parse(item.name)}
            </Option>
          ))}
        </>
      ) : (
        <Option value="no" key="no">
          <FormattedMessage
            id="Add friends to see their tours"
            defaultMessage="Add friends to see their tours"
          />
        </Option>
      )}
    </Select>
  );
};

export default FriendsSelect;
